/**
 * Canonical "Relationship" dropdown options.
 *
 * The single source of truth for every invite/relationship selector so the
 * options stay consistent across surfaces. Mirrors the tenant screening
 * PropertyStep relationship fields (co-applicant + guarantor) exactly — the
 * landlord-portal Add-Applicant / Request-Guarantor dialogs (individual and
 * combined report pages) render this same list. Keep this list in sync with
 * PropertyStep's inline options if either changes.
 */
export const RELATIONSHIP_OPTIONS: ReadonlyArray<{
	label: string
	value: string
}> = [
	{ label: 'Parent', value: 'Parent' },
	{ label: 'Spouse', value: 'Spouse' },
	{ label: 'Partner', value: 'Partner' },
	{ label: 'Sibling', value: 'Sibling' },
	{ label: 'Family', value: 'Family' },
	{ label: 'Friend', value: 'Friend' },
	{ label: 'Employer', value: 'Employer' },
	{ label: 'Other', value: 'Other' },
]

/** Plain values, for string-array consumers (the landlord invite dialogs
 * render `label === value`). */
export const RELATIONSHIP_VALUES: string[] = RELATIONSHIP_OPTIONS.map(
	(option) => option.value,
)

/**
 * @deprecated Use {@link RELATIONSHIP_OPTIONS}. Kept as an alias because the
 * same list serves co-applicants too, not just guarantors.
 */
export const GUARANTOR_RELATIONSHIP_OPTIONS = RELATIONSHIP_OPTIONS
